module.exports = __webpack_public_path__ + "img/unit_White_B.f48c1d72.png";